import { permissionCheck, realPermissionCheck } from "./permission-check";

export const buildAreaAdmin = (navigation, strings, permissions, onClick, flags = []) => {
  var areaId = navigation.area ? navigation.area.id : "na";
  /*var regionId = navigation.region ? navigation.region.id : "na";
  var coordinatorId = navigation.coordinator ? navigation.coordinator.id : "na";
  var programId = navigation.program ? navigation.program.id : "na";*/

  const baseUrl = `/areas/${areaId}`;

  const item = {
    id:7,
    type: "group",
    label: strings.programAdministration,
    "data-id": "accordion-area-admin-group",
    items: [],
  };

  const items = item.items;
  if (permissionCheck(navigation, "readAreaFaculty")) {
    items.push({
      id:8,
      type: "link",
      label: strings.faculty,
      "data-id": "accordion-area-admin-faculty",
      href: `${baseUrl}/faculty`,
      onClick:(e) => {
        onClick({
          event:e,
          href: `${baseUrl}/faculty`,
        });
      }
    });
  }
  const canManage = realPermissionCheck(permissions, "CanEditProgramSupplemental", areaId);
  if (canManage) {
    item.items.push({
      id:9,
      type:"link",
      label: strings.instituteHubs,
      "data-id":"accordian-institute-hubs",
      href:`${baseUrl}/institute-hubs`,
      onClick:(e) => {
        onClick({
          event:e,
          href: `${baseUrl}/institute-hubs`,
        });
      }
    });
  }

  return item;
};
